import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { AccountService } from '../account.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private router: Router
  ) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const isAuthenticated = await this.authService.isAuthenticated();

    if (!isAuthenticated) {
      // If user is not authenticated, redirect to login
      return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    }

    const user = await this.authService.getUser();
    const activeAccount = await firstValueFrom(this.accountService.activeAccountObservable());

    const roles = Array.isArray(user?.roles) ? user.roles : [];
    if ((activeAccount && activeAccount.isBusiness) || roles.includes('business') || roles.includes('admin')) {
      return true;
    }

    // If not a business account, redirect to home.
    return this.router.createUrlTree(['/home']);
  }
}
